module.exports = __webpack_public_path__ + "img/32_6.726fa736.png";